let language = {
    "PT": {
        "voucher": {
            "address": "Endereço",
            "rut": "RUT",
            "phone": "Telefone",
            "voucher": "Voucher",
            "dates": "Datas",
            "products": "Produtos",
            "passagers": "Passageiros",
            "customers_data": "Informações do cliente",
            "customer_name": "Nome do cliente",
            "document": "Documento",
            "about_reservation": "Sobre a reserva",
            "about_budget": "Sobre o orçamento",
            "about_exit": "Sobre a saída",
            "driver": "Motorista",
            "guide": "Guia",
            "date": "Data",
            "value_by_adult": "Valor por adulto",
            "value_by_kid": "Valor por criança",
            "value_by_passagers": "Valor por passageiro",
            "schedule": "Horário",
            "flight_code": "Número do vôo",
            "adults": "Adultos",
            "kids": "Crianças",
            "subtotal": "Subtotal",
            "discount": "Desconto",
            "manager_discount_badge": "Desconto gerencial",
            "manager_discount_line": "Desconto gerencial aprovado",
            "payment_discount_line": "Desconto forma de pagamento",
            "total": "Total",
            "email": "Email",
            "payment_about": "Informações do pagamento",
            "references": "Referência",
            "purchase_date": "Data da compra",
            "last_purchase_date": "Data do último pagamento",
            "total_value": "Valor Total",
            "paid_value": "Valor Pago",
            "pending_value": "Valor Pendente",
            "payment_status": "Status de pagamento",
            "signature": "Assinatura realizada em",
            "waiting_date": "A ser agendado",
            "observation":"Esse orçamento pode sofrer alterações",
            "paid": "Pago",
            "pending": "Pendente",
            "partial": "Parcial",
            "lodging": "Hospedagem",
            "room": "Quarto",
            "fullday": "Integral",
            "halfday": "Meio-período",
            "morning": "Manhã",
            "afternoon": "Tarde",
            "terms_title": "Termos e condições",
            "canceled_notice": "Reserva cancelada por",
            "signed_title": "Contrato assinado eletronicamente",
            "waiting_signature": "Contrato aguardando assinatura do cliente.",
            "sign": "Assinar",
            "show_signature": "Exibir Assinatura",
            "view_pdf": "Visualizar PDF",
            "voucher_sent": "Voucher enviado com sucesso",
            "signer_data": "Dados do assinante:",
            "agree": "Declaro que estou de acordo",
            "code_sent_to": "Código enviado para",
            "code_hint": "Um código foi enviado para seu e-mail. Insira-o abaixo para assinar:",
            "insert_key": "Insira a sua chave de assinatura",
            "resend_code": "Reenviar código por e-mail",
            "sending": "Enviando...",
            "confirm_signature": "Confirmar assinatura",
            "invalid_key": "Chave(s) inválida(s)!",
            "update_ip": "Atualizar IP",
            "signature_done_at": "Assinatura realizada em",
            "transfer": "Transfer",
            "company_id": "ID"
        }
    },
    "EN": {
        "voucher": {
            "address": "Address",
            "rut": "RUT",
            "phone": "Phone",
            "voucher": "Voucher",
            "dates": "Dates",
            "products": "Products",
            "passagers": "Passagers",
            "customers_data": "Customer's data",
            "customer_name": "Customer's name",
            "document": "Document",
            "about_reservation": "About reservation",
            "about_budget": "About the budget",
            "about_exit": "About exit",
            "driver": "Driver",
            "guide": "Guide",
            "date": "Date",
            "value_by_adult": "Value by adult",
            "value_by_kid": "Value by kid",
            "value_by_passagers": "Value by passager",
            "schedule": "Schedule",
            "flight_code": "Flight Code",
            "adults": "Adults",
            "kids": "Kids",
            "subtotal": "Subtotal",
            "discount": "Discount",
            "manager_discount_badge": "Manager discount",
            "manager_discount_line": "Manager discount approved",
            "payment_discount_line": "Payment method discount",
            "total": "Total",
            "email": "Email",
            "payment_about": "About payment",
            "references": "References",
            "purchase_date": "Purchase date",
            "last_purchase_date": "Last payment date",
            "total_value": "Total value",
            "paid_value": "Paid value",
            "pending_value": "Pending value",
            "payment_status": "Payment status",
            "signature": "Signature performed on",
            "waiting_date": "To be booked",
            "observation":"This budget can be chaged",
            "paid": "Paid",
            "pending": "Pending",
            "partial": "Partial",
            "lodging": "Lodging",
            "room": "Room",
            "fullday": "Full day",
            "halfday": "Half day",
            "morning": "Morning",
            "afternoon": "Afternoon",
            "terms_title": "Terms and conditions",
            "canceled_notice": "Reservation canceled by",
            "signed_title": "Contract electronically signed",
            "waiting_signature": "Contract awaiting customer signature.",
            "sign": "Sign",
            "show_signature": "View Signature",
            "view_pdf": "View PDF",
            "voucher_sent": "Voucher sent successfully",
            "signer_data": "Signer details:",
            "agree": "I declare that I agree",
            "code_sent_to": "Code sent to",
            "code_hint": "A code was sent to your e-mail. Enter it below to sign:",
            "insert_key": "Enter your signature key",
            "resend_code": "Resend code by e-mail",
            "sending": "Sending...",
            "confirm_signature": "Confirm signature",
            "invalid_key": "Invalid key(s)!",
            "update_ip": "Update IP",
            "signature_done_at": "Signature performed on",
            "transfer": "Transfer",
            "company_id": "ID"
        }
    },
    "ES": {
        "voucher": {
            "address": "Dirección",
            "rut": "RUT",
            "phone": "Teléfono",
            "voucher": "Voucher",
            "dates": "Fechas",
            "products": "Productos",
            "passagers": "Pasajeros",
            "customers_data": "Datos del cliente",
            "customer_name": "Nombre del cliente",
            "document": "Documento",
            "about_reservation": "Sobre la reserva",
            "about_budget": "Sobre el presupuesto",
            "about_exit": "Sobre la salida",
            "driver": "Conductor",
            "guide": "Guía",
            "date": "Fecha",
            "value_by_adult": "Valor por adulto",
            "value_by_kid": "Valor por niño",
            "value_by_passagers": "Valor por pasajero",
            "schedule": "Horario",
            "flight_code": "Número de Vuelo",
            "adults": "Adultos",
            "kids": "Niños",
            "subtotal": "Subtotal",
            "discount": "Descuento",
            "manager_discount_badge": "Descuento gerencial",
            "manager_discount_line": "Descuento gerencial aprobado",
            "payment_discount_line": "Descuento por forma de pago",
            "total": "Total",
            "email": "Email",
            "payment_about": "Datos del pago",
            "references": "Referencias",
            "purchase_date": "Fecha de compra",
            "last_purchase_date": "Última fecha de pago",
            "total_value": "Valor total",
            "paid_value": "Valor pagado",
            "pending_value": "Valor pendiente",
            "payment_status": "Estado de pago",
            "signature": "Firma realizada en",
            "waiting_date": "Esperando la cita",
            "observation":"Este presupuesto puede ser modificado",
            "paid": "Pagado",
            "pending": "Pendiente",
            "partial": "Parcial",
            "lodging": "Alojamiento",
            "room": "Habitación",
            "fullday": "Día completo",
            "halfday": "Medio día",
            "morning": "Mañana",
            "afternoon": "Tarde",
            "terms_title": "Términos y condiciones",
            "canceled_notice": "Reserva cancelada por",
            "signed_title": "Contrato firmado electrónicamente",
            "waiting_signature": "Contrato esperando la firma del cliente.",
            "sign": "Firmar",
            "show_signature": "Ver Firma",
            "view_pdf": "Ver PDF",
            "voucher_sent": "Voucher enviado con éxito",
            "signer_data": "Datos del firmante:",
            "agree": "Declaro que estoy de acuerdo",
            "code_sent_to": "Código enviado a",
            "code_hint": "Se envió un código a su correo. Ingréselo abajo para firmar:",
            "insert_key": "Ingrese su clave de firma",
            "resend_code": "Reenviar código por correo",
            "sending": "Enviando...",
            "confirm_signature": "Confirmar firma",
            "invalid_key": "¡Clave(s) inválida(s)!",
            "update_ip": "Actualizar IP",
            "signature_done_at": "Firma realizada el",
            "transfer": "Transfer",
            "company_id": "ID"
        }
    }
}

export default language;
